const generateUniqType = <T extends string>(type: T) =>
  `__semiologic__${type}__semiologic__` as const;

export const SELF_CLOSE_IFRAME = generateUniqType('SELF_CLOSE_IFRAME');
export const TOKEN_EXCHANGE = generateUniqType('TOKEN_EXCHANGE');
export const COMMAND = generateUniqType('COMMAND');
export const HAND_SHAKE = generateUniqType('HAND_SHAKE');
export const EMAIL_VALIDATION_MSG = generateUniqType('EMAIL_VALIDATION_MSG');
export const FETCH_GL = generateUniqType('FETCH_GL');
export const FETCH_GL_RESP = generateUniqType('FETCH_GL_RESP');
export const RESIZE_GL = generateUniqType('RESIZE_GL');
